




















































































































































import { Component, Prop } from 'vue-property-decorator';
import Form from '@/layouts/Form';

import InputBase from '@/components/input/Input.vue';

import {PartnerResponse, PartnerRequest, Address, Phone, Group} from '@/types/models/partners';

import PartnerEntityModule from '@/store/partners/entity';

import {Numeric, Photo} from '@/types/common';
import CheckboxBase from "@/components/checkbox/Checkbox.vue";
import ErrorField from "@/components/form/ErrorField.vue";
import BaseEditor from "@/components/editor/BaseEditor.vue";
import SelectCustom from "@/components/select/SelectCustom.vue";
import {getPartnerGroups} from "@/api/partnerGroups";
import BaseButton from "@/components/buttons/BaseButton.vue";
import ImageInputEntity from "@/components/image-input/ImageInputEntity.vue";

interface FormValues {
    group: Group | null,
    partnerName: string,
    title: string,
    description: string,
    offer: string,
    condition: string, // html
    sort: Numeric,
    isActive: boolean,
    image: Photo | null,
    addresses: Address[],
    phones: Phone[],
}

@Component({
    components: {
        ImageInputEntity,
        BaseButton,
        SelectCustom,
        BaseEditor, ErrorField,
        CheckboxBase,
        InputBase,
    },
})
export default class partnersForm extends Form {
    @Prop() formValues?: PartnerResponse; // initial values
    @Prop({ type: Object, default: () => ({}) }) errors!: Record<string, string>;

    values: FormValues = {
        group: null,
        partnerName: '',
        title: '',
        description: '',
        offer: '',
        condition: '',
        sort: 1,
        isActive: true,
        image: null,
        addresses: [],
        phones: [],
    };

    listGroups = [{id: '', value: 'Не выбрана'}];

    validationErrors: Partial<Record<keyof FormValues, string>> = {}

    get allErrors() {
        return {
            ...this.errors,
            ...this.validationErrors,
        }
    }

    get model() {
        return PartnerEntityModule.model;
    }

    returnBefore() {
        this.$router.push({ name: 'partners' });
    }

    initFormValues() {
        if (!this.formValues) {
            return;
        }

        const {
            group: initialGroup,
            partnerName = '',
            title = '',
            description = '',
            offer = '',
            condition = '',
            sort = 1,
            isActive = true,
            image = null,
            addresses = [],
            phones = [],
        } = this.formValues;

        const group: any = this.listGroups.find(el => el.id === initialGroup)

        this.values = {
            group,
            partnerName,
            title,
            description,
            offer,
            condition,
            sort,
            isActive,
            image,
            addresses,
            phones,
        }
    }

    async createNew() {
        return this.update();
    }

    async update() {
        const data = this.prepareData();

        this.$emit('submit', data);
    }

    prepareData() {
        const {
            group,
            partnerName,
            title,
            description,
            offer,
            condition,
            sort,
            isActive,
            image,
            addresses,
            phones,
        } = this.values;

        const request: PartnerRequest = {
            group: null,
            partnerName,
            title,
            description,
            offer,
            condition,
            sort,
            isActive,
            addresses,
            phones,
        };

        if (group?.id) {
            request.group = group.id;
        }

        if (image?.file) {
            request.image = image.file;
        }

        console.warn(request);

        return request;
    }

    addAddress() {
        this.values.addresses.push({ name: '', address: '' });
    }

    removeAddress(index: any) {
        this.values.addresses.splice(index, 1);
    }

    addPhone() {
        this.values.phones.push({ phone: '' });
    }

    removePhone(index: any) {
        this.values.phones.splice(index, 1);
    }

    updateCondition(content: string) {
        this.values.condition = content;
    }

    async mounted() {
        const partnerGroups = await getPartnerGroups();

        const groups = Object.keys(partnerGroups.result.table.rows).filter(key => key).map((key: string) => {
            return {
                id: partnerGroups.result.table.rows[key].id,
                value: partnerGroups.result.table.rows[key].title,
            }
        });

        this.listGroups = this.listGroups.concat(groups);
        this.initFormValues();
    }
}
